import { MarkdownRenderer } from '@/components/markdown';

import { ActivityFeed } from './activity-feed';
import {
  groupTimeline,
  segmentsStartedAt,
  type TurnSegment,
} from './turn-timeline';

export const REPLY_TEXT_CLASS =
  'space-y-3 text-base leading-6 [overflow-wrap:anywhere]';

interface TurnBlocksProps {
  timeline: TurnSegment[];
  streaming: boolean;
  replyInProgress: boolean;
}

export function TurnBlocks({
  timeline,
  streaming,
  replyInProgress,
}: TurnBlocksProps) {
  const blocks = groupTimeline(timeline);
  const lastIndex = blocks.length - 1;

  return (
    <>
      {blocks.map((block, i) =>
        block.kind === 'text' ? (
          <MarkdownRenderer
            key={`text-${i}`}
            content={block.text}
            className={REPLY_TEXT_CLASS}
          />
        ) : (
          <ActivityFeed
            key={`steps-${i}`}
            timeline={block.segments}
            streaming={streaming && i === lastIndex && !replyInProgress}
            startedAt={segmentsStartedAt(block.segments)}
          />
        ),
      )}
    </>
  );
}
